<template>
  <div class="space-y-8">
    <FormattedMessage class="text-static-default-hi body-1" :definition="title">
      <template #deviceName>
        <span class="body-1-bold"> {{ model }}</span>
      </template>
    </FormattedMessage>

    <div class="space-y-12">
      <InsuranceOffers
        :id="listingId"
        data-test="insurances"
        :offers="insuranceOffers"
        :selected-offer-id
        :tracking-zone
        @remove="emit('remove')"
        @select="(offer) => emit('select', offer)"
      />

      <InsuranceProvider :has-backup-plus-offers :tracking-zone :with-link />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type {
  InsuranceOffer,
  InsuranceOfferWithSelectedState,
} from '@backmarket/http-api'
import FormattedMessage from '@backmarket/nuxt-module-i18n/FormattedMessage.vue'

import InsuranceOffers from '~/scopes/insurance/components/InsuranceOffers/InsuranceOffers.vue'
import InsuranceProvider from '~/scopes/insurance/components/InsuranceOffers/components/InsuranceProvider/InsuranceProvider.vue'

import translations from './InsuranceSelection.translations'

const props = withDefaults(
  defineProps<{
    listingId: string
    model: string
    selectedOfferId?: string | number
    insuranceOffers: InsuranceOfferWithSelectedState[]
    trackingZone?: string
    withLink?: boolean
  }>(),
  {
    selectedOfferId: '',
    trackingZone: 'cart',
    withLink: true,
  },
)

const hasBackupPlusOffers = computed(() => {
  return props.insuranceOffers.some((offer) => offer.isBackupPlus)
})

const emit = defineEmits<{
  select: [updatedInsuranceOffers: InsuranceOffer]
  remove: []
}>()

const title = computed(() => {
  return hasBackupPlusOffers.value
    ? translations.backupPlusTitle
    : translations.title
})
</script>
